/// <reference path="../../../../tools/typings/angularjs/angular.d.ts"/>

module DealerwareWebComponents {
    "use strict";

    export class FleetMapController {
        public static $inject: string[] = [
            '$q',
            '$timeout',
            '$scope',
            '$filter',
            'NgMap',
            'DealerwareLocationCollection',
            'DealerwareFleetCollection',
            '$mobilityCompanyAuthentication',
            '$dealerwareNotification',
            '$dealerwareInternationalizationData',
        ];

        public mapConfig: any;
        public mapCenter: any;
        public mapZoom: any;
        public markers: any;
        public filterPanel: string;
        public selectedStates: any;
        public filters: any;
        public collapsed: boolean;
        public loading: boolean;
        public labels: any;

        constructor(public $q: any,
                    public $timeout: any,
                    public $scope: any,
                    public $filter: any,
                    public NgMap: any,
                    public locationCollection: any,
                    public fleetCollection: any,
                    public $auth: any,
                    public $dealerwareNotification: any,
                    public $dealerwareInternationalizationData: any,
        ) {
            this.getLabels('vehicles');

            this.mapConfig = {
                infoWindowTemplate: '/components/dashboard_widgets/fleet_map/fleet_map_info_window_template.html',
                markerKey: 'current_state',
                scrollToZoom: false,
                markerColors: {
                    disposed: '999999',             // grey
                    hard_hold: 'ffa31a',            // orange
                    in_prep: 'b3c6ff',              // light purple
                    maintenance: 'ff0000',          // red
                    rented: '66c0e0',               // light blue
                    returned: '3333cc',             // blue
                    shuttle: 'ffb3ff',              // pink
                    staged: '009900',               // green
                    totaled_pending_ins: 'ffff00'   // yellow
                }
            };

            this.initMap();
        }

        public getLabels(module: string): void {
            const _self = this;
            this.$dealerwareInternationalizationData
                .getLabels()
                .then( function(res) {
                    _self.labels = _self.$dealerwareInternationalizationData.getLabelsByModule(res.data, module);

                },
                function(error: any) {
                    _self.$dealerwareNotification.apiError(error);
                }
            );
        }

        private shouldShowMarker(data: any) : boolean {
            return (data.latitude && data.latitude != 0 &&
                    data.longitude && data.longitude != 0);
        }

        private geocodeAddress(location: any) : ng.IPromise<{}> {
            var _deferred = this.$q.defer(),
                _self = this;

            this.NgMap.getMap().then(function(map: any) {
                _self.NgMap.getGeoLocation(
                    location.address.street_number + ' ' +
                    location.address.street_name + ',' +
                    location.address.city + ',' +
                    location.address.state + ' ' +
                    location.address.zip
                ).then(
                    function(result: any) { _deferred.resolve({ lat: result.lat(), lng: result.lng() }); },
                    function() { _deferred.reject({ lat: 39.8282, lng: -98.5795 }); }
                );
            });

            return _deferred.promise;
        }

        private enableMapControls(enable: boolean) : void {
            var _self = this;

            this.NgMap.getMap().then(function(map: any) {
                map.setOptions({
                    draggable: enable,
                    disableDefaultUI: !enable,
                    disableDoubleClickZoom: !enable
                });
                google.maps.event.trigger(map, 'resize');
            });
        }

        public get enableMap() : boolean {
            return this.$auth.location && this.$auth.location.has_ccs;
        }

        public get carStates() : any {
            let states: string[] = [];

            if (this.markers && this.markers.length && this.markers[0].data.hasOwnProperty('vin')) {
                this.markers.forEach(function(marker: any) {
                    if ($.inArray(marker.data.current_state, states) === -1) {
                        states.push(marker.data.current_state);
                    }
                });
            }

            return states;
        }

        public showFilterPanel(filter: string) : void {
            this.filterPanel = this.filterPanel === filter ? this.filterPanel = undefined : this.filterPanel = filter;
        }

        public toggleCollapsed() : void {
            this.collapsed = !this.collapsed;
        }

        public initMap() : void {
            this.loading = true;
            this.showCarMarkers();
            this.enableMapControls(this.enableMap || !this.$auth.location);
        }

        public showCarMarkers() : void {
            var _self = this;

            this.markers = [];

            if (this.$auth.location) {
                this.mapZoom = 18;

                if (!this.$auth.location.address.latitude || !this.$auth.location.address.longitude) {
                    this.geocodeAddress(this.$auth.location).then(
                        function(coords: any) { _self.mapCenter = { lat: coords.lat, lng: coords.lng }; },
                        function(coords: any) { _self.mapCenter = { lat: coords.lat, lng: coords.lng }; }
                    );
                } else {
                    this.$timeout(() => {
                        _self.mapCenter = {
                            lat: parseFloat(_self.$auth.location.address.latitude),
                            lng: parseFloat(_self.$auth.location.address.longitude)
                        };
                    }, 100);
                }
            }

            if (this.enableMap) {
                this.fleetCollection.forLocation({
                    promise: true,
                    params: { location_id: this.$auth.location.id }
                }).then(
                    function(cars: any) {
                        _self.markers = _self.$filter('filter')(cars.data, function(car: any) {
                            return _self.shouldShowMarker(car.data);
                        });
                        _self.selectedStates = {};

                        _self.markers.forEach(function(marker: any) {
                            _self.selectedStates[marker.data.current_state] = true;
                        });

                        _self.filterCarStates();
                    },
                    function(response: any) { _self.$dealerwareNotification.apiError(response); }
                ).finally(
                    function() { _self.loading = false; }
                );
            } else {
                this.loading = false;
            }
        }

        public filterCarStates() {
            this.filters = { current_state: [] };

            for (var state in this.selectedStates) {
                if (this.selectedStates[state]) {
                    this.filters.current_state.push(state);
                }
            }
        }

        public lookupMarkerIcon(state: string) : string {
            var color = 'fe7569';

            if (this.mapConfig.hasOwnProperty('markerColors')) {
                if (typeof(this.mapConfig.markerColors) === 'string') {
                    color = this.mapConfig.markerColors;
                } else if (this.mapConfig.markerColors.hasOwnProperty(state)) {
                    color = this.mapConfig.markerColors[state];
                }
            }

            return '../../images/map/markers/' + color + '.png';
        }
    }

    getDealerwareWebComponentsModule().controller('FleetMapController', FleetMapController);

    export class FleetMapDirective implements ng.IDirective {
        public restrict         : string    =   'E';
        public controller       : any       =   'FleetMapController';
        public controllerAs     : string    =   'fleetMapController';
        public bindToController : boolean   =   true;
        public replace          : boolean   =   false;
        public transclude       : boolean   =   false;
        public templateUrl      : string    =   '/components/dashboard_widgets/fleet_map/fleet_map_directive.html';
        public static $inject   : string[]  =   [];

        constructor() {}

        public link : ng.IDirectiveLinkFn = (
            scope   :   ng.IScope,
            element :   ng.IAugmentedJQuery,
            attrs   :   ng.IAttributes,
            ctrls   :   any
        ) => {}
    }

    // register the directive
    getDealerwareWebComponentsModule().directive("dealerwareFleetMap",() => new FleetMapDirective());
}
